import type { Routes } from '../../shares/types';
import { KolibriBasic } from './basic';

export const KOLIBRI_ROUTES: Routes = {
	kolibri: {
		basic: KolibriBasic,
	},
};
